import { isMobile } from 'react-device-detect';
import './HowItWorks.css';

// Desktop SVGs
import HowItWorksDesktop from '../../assets/images/svg/how-it-works-desktop.svg';
import HowItWorksDesktopThankyou from '../../assets/images/svg/how-it-works-desktop-thankyou.svg';

// Mobile SVGs
import HowItWorksMobile from '../../assets/images/svg/how-it-works-mobile.svg';
import HowItWorksMobileThankyou from '../../assets/images/svg/how-it-works-mobile-thankyou.svg';

/**
 * HowItWorks - Displays the "How it works" section with step illustrations
 * Shows different SVGs based on device type and thank you state
 *
 * @param {boolean} isThankYou - Whether the thank you message is displayed
 */
export default function HowItWorks({ isThankYou = false }) {
    // Select the appropriate SVG based on device and thank you state
    const getSvgSource = () => {
        if (isMobile) {
            return isThankYou ? HowItWorksMobileThankyou : HowItWorksMobile;
        }
        return isThankYou ? HowItWorksDesktopThankyou : HowItWorksDesktop;
    };

    return (
        <section className="how-it-works">
            <div className="content-container">
                <h1 className="how-it-works__title">איך זה עובד?</h1>
                <img
                    src={getSvgSource()}
                    alt="1. הרשמה 2. וידוא שלנו 3. יציאה להתנדבות"
                    className="how-it-works__image"
                />
            </div>
        </section>
    );
}
